import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MembersCardsListComponent } from './members-cards-list.component';

import { AccountCardModule } from '../../account/account-card/account-card.module';
import { GroupMembershipPipeModule } from '../../pipes/group-membership-pipe/group-membership-pipe.module';
import { ProgressSpinnerModule } from '../../progress-spinner/progress-spinner.module';

@NgModule({
  imports: [
    AccountCardModule,
    CommonModule,
    FlexLayoutModule,
    GroupMembershipPipeModule,
    InfiniteScrollModule,
    ProgressSpinnerModule,
    RouterModule,
  ],
  declarations: [MembersCardsListComponent],
  exports: [MembersCardsListComponent],
})
export class MembersCardsListModule {}
